/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Pre_ConfInputs */

/** @type {(inputs: Auto_Pre_ConfInputs) => LocalizedString} */
const fr_auto_pre_conf = () => /** @type {LocalizedString} */ ('auto_pre_conf')

/**
* | output |
* | --- |
* | "Unusual absence detection" |
*
* @param {Auto_Pre_ConfInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auto_pre_conf = /** @type {((inputs?: Auto_Pre_ConfInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Pre_ConfInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Unusual absence detection")
	return fr_auto_pre_conf(inputs)
});